var _mask, _path, _mask2, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeatureLeaf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.014 10a57.106 57.106 0 0 1 6.293-4.24s9.157 16.483 5.496 29.307C55.53 43.016 50.69 46.9 45.333 47.304"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.788 8.42a2 2 0 1 0 2.45 3.16l-2.45-3.16Zm7.519-2.66h2V2.285L51.302 4.03l1.005 1.729Zm5.496 29.307 1.923.55v-.001l-1.923-.55ZM45.183 45.31a2 2 0 1 0 .3 3.988l-.3-3.988Zm2.056-33.73a55.113 55.113 0 0 1 6.073-4.09l-2.01-3.46a59.104 59.104 0 0 0-6.514 4.39l2.45 3.16Zm3.068-5.82c.064.502.251.971.251.97l.003.006.016.029.068.126c.06.114.152.286.267.513.232.453.563 1.122.95 1.966a61.733 61.733 0 0 1 2.661 6.844c1.795 5.61 3.022 12.47 1.357 18.304l3.846 1.098c1.996-6.99.475-14.784-1.393-20.621A65.738 65.738 0 0 0 55.498 7.7a55.994 55.994 0 0 0-1.325-2.695 22.508 22.508 0 0 0-.114-.21l-.002-.005-.001-.001s.187.468.25.97h-4Zm5.573 28.757c-2.104 7.36-6.379 10.468-10.696 10.793l.3 3.988c6.396-.48 11.801-5.144 14.242-13.682l-3.846-1.099Z",
    fill: "#F58020",
    mask: "url(#a)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.653 10A57.1 57.1 0 0 0 6.36 5.76S-2.797 22.243.864 35.067c2.272 7.944 7.112 11.829 12.47 12.232"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.428 11.58a2 2 0 0 0 2.45-3.16l-2.45 3.16ZM6.36 5.76l-1.789.894.268.535.516.3L6.36 5.76ZM.864 35.067l-1.923.549 1.923-.55Zm12.32 14.226a2 2 0 0 0 .3-3.989l-.3 3.99Zm.695-40.874a59.11 59.11 0 0 0-6.514-4.388l-2.01 3.458a55.103 55.103 0 0 1 6.073 4.092l2.45-3.162ZM8.36 5.76c-1.498-1.936-3.748-.97-3.749-.97v.001l-.003.004-.007.013a15.173 15.173 0 0 0-.107.198 36.27 36.27 0 0 0-.3.577C3.937 6.08 3.582 6.8 3.168 7.7a65.734 65.734 0 0 0-2.835 7.294c-1.868 5.838-3.389 13.63-1.393 20.62l3.846-1.097c-1.665-5.835-.438-12.695 1.357-18.304a61.736 61.736 0 0 1 2.66-6.844 52.09 52.09 0 0 1 1.218-2.48 16.99 16.99 0 0 1 .084-.154l.003-.005s-2.25.965-3.749-.971h4Zm-9.419 29.857c2.44 8.533 7.846 13.195 14.243 13.676l.3-3.989C9.164 44.98 4.89 41.872 2.786 34.517l-3.846 1.1Z",
    fill: "#F58020",
    mask: "url(#b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.334 58V31.333M16 28.667C16 15.333 29.333 2 29.333 2s13.334 13.333 13.334 26.667c0 10.666-5.971 16-13.334 16-7.362 0-13.333-5.334-13.333-16Z",
    stroke: "#1C1E22",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureLeaf);
export default __webpack_public_path__ + "static/media/feature-leaf.6312e973.svg";
export { ForwardRef as ReactComponent };